module.exports = __webpack_public_path__ + "static/media/cancel.99765438.svg";